import config from '../Config';
import OaCrmWebApi from '@telia-oa/eventapi-client';
import ErrorUtil from '../error/ErrorUtil';
import RootStore from './RootStore';
import SsoStore from './SsoStore';

export default class OnlineHelpEventStore {
  public oaCrmWebApi: OaCrmWebApi;
  private ssoStore: SsoStore;

  constructor(rootStore: RootStore) {
    this.ssoStore = rootStore.ssoStore;
    const { EventApiEnvironment: env, string: project } = this.getOaCrmWebApiBuildParams();

    if (['dev', 'test', 'live'].includes(env)) {
      this.oaCrmWebApi = new OaCrmWebApi(env, project, this.getCustomerId);
    }
  }

  public getCustomerId = (): string => {
    return this.ssoStore.customerId && `${this.ssoStore.customerId}`;
  };

  getOaCrmWebApiBuildParams = (): any => {
    return {
      env: config.env,
      project: 'tweb'
    };
  };

  public recordEvent = (eventName: string): void => {
    try {
      this.oaCrmWebApi?.record(null, { name: eventName }, null);
    } catch (exception) {
      ErrorUtil.pushErrorToTeliaRumAndLog(exception as Error);
    }
  };
}
